import { Box, ButtonBase } from '@mui/material';
import { styled } from '@mui/material/styles';

export const StyledCollapse = styled(Box)(({ theme }) => ({
  width: '370px',
  background: theme.palette.common.white,
  borderRadius: '6px',
  overflow: 'hidden',
  boxShadow: '0 4px 16px rgba(103, 113, 121, 0.15)',
  [theme.breakpoints.down('md')]: {
    right: 24,
  },
  [theme.breakpoints.down('sm')]: {
    width: '275px',
    right: 0,
  },
  border: `1px solid ${theme.palette.border.main}`,
}));

export const StyledButton = styled(ButtonBase)(({ theme }) => ({
  color: theme.palette.general.lightGrey2,
  height: '100%',
}));

export const StyledShoppingCart = styled(
  'div',
)<{ kioskMode: boolean; managementMode: boolean }>(({ theme, kioskMode, managementMode }) => ({
  borderRadius: kioskMode ? '40px' : '6px',
  padding: theme.spacing(0.5, kioskMode ? 3 : 1.5),
  display: 'flex',
  alignItems: 'center',
  height: kioskMode && !managementMode ? '80px' : '42px',
  gap: kioskMode ? theme.spacing(2) : theme.spacing(1),
  backgroundColor: theme.palette.common.white,

  '&:hover': {
    backgroundColor: theme.palette.background.secondary,
  },

  '& .MuiBadge-badge': {
    ...(kioskMode ? {
      height: '30px',
      minWidth: '30px',
      fontSize: '1.4rem',
      borderRadius: '15px',
    } : {}),
  },

  [theme.breakpoints.down('md')]: {
    padding: theme.spacing(0.5, 1.5),
    '& .name': {
      display: 'none',
    },
  },

  [theme.breakpoints.down('sm')]: {
    padding: theme.spacing(0.5, 1),
  },
}));
